export default "__VITE_ASSET__352eb665__"